import * as zod from 'zod';

import { CartesianPose, ZERO_ROTATION } from '@sb/geometry';
import { CollisionBoxConfig } from '@sb/integrations/types/CollisionBox';

import {
  ROBOTIQ_EPICK_DEFAULT_COLLISION_BOX,
  ROBOTIQ_EPICK_MASS_KG,
  ROBOTIQ_EPICK_TCP_Z_OFFSET,
} from '../constants';

export const RobotiqEPickConfiguration = zod.object({
  kind: zod.literal('RobotiqEPick'),
  name: zod.string().default('EPick'),
  tcpTransform: CartesianPose.default({
    ...ZERO_ROTATION,
    x: 0,
    y: 0,
    z: ROBOTIQ_EPICK_TCP_Z_OFFSET,
  }),
  massKg: zod.number().default(ROBOTIQ_EPICK_MASS_KG),
  collisionBox: CollisionBoxConfig.default(ROBOTIQ_EPICK_DEFAULT_COLLISION_BOX),
});

export type RobotiqEPickConfiguration = zod.infer<
  typeof RobotiqEPickConfiguration
>;
